import { KeyDescriptionViewModel, DecisionModel } from './keyDescriptionViewModel';

export class CustomReportModel {
  selectedTeams: Array<any> = [-1];
  pcnNumber = '';
  usersIds: Array<number> = [-1];
  selectedContraventions: Array<any> = [-1];
  startDate: Date = new Date;
  stages: Array<any> = [-1];
  endDate: Date = new Date;
  selectedBespoke: Array<any> = [-1];
  selectedPcnTypes: Array<any> = [-1];
  selectedDecisions: Array<any> = [-1];
  selectedPcnPrefixes: Array<any> = [-1];
  selectedUfus: Array<any> = [-1];
  selectedOverrides: Array<any> = [-1];
  selectedReasons: Array<any> = [-1];
  location = '';
}

export class CustomReportRequestModel {
  pcnNumber: string;
  startDate: Date;
  endDate: Date;
  usersIds: Array<number>;
  stages: Array<KeyDescriptionViewModel>;
  offenceTypes: Array<KeyDescriptionViewModel>;
  pcnTypes: Array<KeyDescriptionViewModel>;
  pcnPrefix: Array<KeyDescriptionViewModel>;
  decisions: Array<KeyDescriptionViewModel>;
  bespoke: Array<DecisionModel>;
  ufu: Array<DecisionModel>;
  reasons: Array<KeyDescriptionViewModel>;
  override: Array<DecisionModel>;
  location: string;
}
